import { useState } from 'react';
import { useAuth } from '../AuthContext';

export function EmailLoginForm() {
  const { loginWithEmail, registerWithEmail, loginWithGoogle } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [googleSubmitting, setGoogleSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      if (isRegistering) {
        await registerWithEmail(email, password);
      } else {
        await loginWithEmail(email, password);
      }
    } catch (err) {
      setError(isRegistering ? 'No se pudo crear la cuenta' : 'Credenciales incorrectas');
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoogle = async () => {
    setError('');
    setGoogleSubmitting(true);
    try {
      await loginWithGoogle();
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        setError('No se pudo iniciar sesión con Google');
      }
    } finally {
      setGoogleSubmitting(false);
    }
  };

  const inputClass =
    'w-full rounded border border-lounge-line bg-lounge-base px-4 py-3 text-[16px] text-lounge-text ' +
    'placeholder:text-lounge-stone outline-none transition-colors ' +
    'focus:border-lounge-brass/60 focus:ring-2 focus:ring-lounge-brass/20';
  const labelClass = 'mb-1.5 block font-mono text-[11px] uppercase tracking-[0.15em] text-lounge-stone';

  return (
    <form onSubmit={handleSubmit} className="flex w-full flex-col gap-4">
      <div>
        <label htmlFor="login-email" className={labelClass}>Correo electrónico</label>
        <input
          id="login-email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="bar@tudominio.com"
          required
          className={inputClass}
        />
      </div>
      <div>
        <label htmlFor="login-password" className={labelClass}>Contraseña</label>
        <input
          id="login-password"
          type="password"
          autoComplete={isRegistering ? 'new-password' : 'current-password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className={inputClass}
        />
      </div>

      {error && (
        <p role="alert" className="m-0 rounded border border-stop/30 bg-stop/10 px-4 py-2.5 text-sm text-stop-soft">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="mt-1 h-12 rounded bg-lounge-brass font-semibold text-lounge-base transition-all
                   hover:bg-amber hover:shadow-brass active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
      >
        {submitting
          ? 'Procesando...'
          : isRegistering
            ? 'Registrarse'
            : 'Iniciar sesión'}
      </button>

      <div className="flex items-center gap-3">
        <hr className="flex-1 border-lounge-line" />
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-lounge-stone">o</span>
        <hr className="flex-1 border-lounge-line" />
      </div>

      <button
        type="button"
        onClick={handleGoogle}
        disabled={googleSubmitting}
        className="flex h-12 w-full items-center justify-center gap-3 rounded border border-lounge-line
                   bg-lounge-raised text-sm font-medium text-lounge-text transition
                   hover:border-white/20 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
          <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
          <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
          <path fill="#FBBC05" d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z"/>
          <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 6.293C4.672 4.166 6.656 3.58 9 3.58z"/>
        </svg>
        {googleSubmitting ? 'Procesando...' : 'Continuar con Google'}
      </button>

      <button
        type="button"
        onClick={() => { setIsRegistering(!isRegistering); setError(''); }}
        className="min-h-[44px] text-sm text-lounge-stone transition hover:text-lounge-text"
      >
        {isRegistering ? '¿Ya tienes cuenta? Inicia sesión' : '¿No tienes cuenta? Regístrate'}
      </button>
    </form>
  );
}
